import { Icon, IconProps } from '@elkaso-app/web-design';
import { HiClipboardList } from 'react-icons/hi';

export const AggSheetIcon = (props: IconProps) => {
  return <Icon as={HiClipboardList} width='24px' height='24px' viewBox='0 0 24 24' fill='#757575' {...props} />;
};
